import React, { useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

const SearchableSelector = ({ value, handleChange, sx, name }) => {
  const [searchKey, setSearchKey] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    if (!searchKey || searchKey.trim() === "") {
      setOptions([]);
      return;
    }
    const getMerchants = async () => {
      const trimmed = searchKey.trim();
      const payload = {
        page: 0,
        size: 20,
      };
      if (trimmed.includes("@")) {
        payload.email = trimmed;
      } else if (/^\+?\d+$/.test(trimmed)) {
        payload.phoneNumber = trimmed;
      } else {
        const parts = trimmed.split(/\s+/);
        if (parts.length > 1) {
          payload.firstName = parts[0];
          payload.lastName = parts.slice(1).join(" ");
        } else {
          payload.firstName = trimmed;
        }
      }
      try {
        const response = await axiosPrivate.post(
          "/auth-serviceV3/admin/users/search",
          payload
        );
        const users = response?.data?.data?.users || response?.data?.data?.content || response?.data?.data || [];
        setOptions(users);
      } catch (error) {
        console.log(error);
      }
    };

    const timer = setTimeout(() => {
      getMerchants();
    }, 400);
    return () => clearTimeout(timer);
  }, [searchKey, axiosPrivate]);

  return (
    <Autocomplete
      value={value}
      name={name}
      onChange={handleChange}
      options={options}
      getOptionLabel={(opt) => {
        if (!opt) return "";
        const first = opt.firstName || "";
        const last = opt.surname || opt.lastName || "";
        const email = opt.email || "";
        const uid = opt.userId || opt.id || "";
        return `${first} ${last} - ${email} - ${uid}`.trim();
      }}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            onChange={(e) => setSearchKey(e.target.value)}
            label="Search User"
            variant="outlined"
          />
        );
      }}
      sx={sx}
    />
  );
};

export default SearchableSelector;
